import { useContext, useEffect } from 'react';
import '../_rollupPluginBabelHelpers-3b7bd988.js';
import { DashboardContext } from './DashboardContext.js';

function useDashboard(onStorageSave = null) {
  const context = useContext(DashboardContext);
  if (!context) {
    throw Error('Missing dashboard context provider');
  }
  const [state] = context;
  useEffect(() => {
    if (onStorageSave) {
      onStorageSave(state.widgets);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);
  return context;
}

export default useDashboard;
